<template>
  <!-- eslint-disable vue/no-v-html -->
  <div>
    <div
      :class="$isMobile ? 'text-h5' : 'text-h4 mt-10'"
      class="mb-2 primary-grey--text font-weight-regular"
      v-html="typedSections.welcome1"
    />
    <div
      :class="$isMobile ? 'text-subtitle-1' : 'text-h5'"
      class="mb-2 primary-grey--text font-weight-regular"
      v-html="typedSections.welcome2"
    />
    <div
      :class="$isMobile ? 'text-body-1 mb-6' : 'text-h5'"
      class="primary-grey--text font-weight-regular"
      v-html="typedSections.welcome3"
    />
    <div
      :class="$isMobile ? 'text-body-2' : 'text-body-1'"
      class="primary-grey--text mb-4"
      :style="!$isMobile ? { maxWidth: '50%', margin: '0 auto' } : {}"
    >
      <br v-if="!$isMobile">
      <div
        v-for="(bullet, i) in welcomeBullets"
        :key="i"
        class="d-flex align-start text-left mb-6"
        v-html="bullet"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SinoaWelcomeContent',

  props: {
    typedSections: {
      type: Object,
      required: true,
    },
  },

  computed: {
    welcomeBullets() {
      return [
        this.typedSections.bulletWelcome1,
        this.typedSections.bulletWelcome2,
      ];
    },
  },
};
</script>
